import React from 'react'
import { shallow } from 'enzyme'

import { CategoryQuestions } from '../../components'

describe('CategoryQuestions', () => { 
  let wrapper, props, instance

  beforeAll(() => {
    props = {
      questions: [
        {
          rid: 1
        }
      ],
      entity: {
        answers: []
      },
      isEditable: true
    }
    wrapper = shallow(<CategoryQuestions {...props} />)
    instance = wrapper.instance()
  })

  describe("#render", () => {
    it("renders", () => {
      expect(wrapper).toBeTruthy()
    })
  })

  describe("#renderQuestions", () => {
    it("renders", () => {
      const renderQuestions = instance.renderQuestions()

      expect(renderQuestions).toBeTruthy()
    })
  })
})
